import { ExcelExport } from "@progress/kendo-react-excel-export";
import * as React from "react";
import { State } from "@progress/kendo-data-query";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import axios, { AxiosResponse } from "axios";
import FileDownload from "js-file-download";
import PageMenuItem from "../../../Layout/PageMenu/PageMenuItem";
import StyledPageMenuIcon from "../../../Layout/PageMenu/PageMenuIcon";

import {
  EXCEL_EXPORT_FAILURE_MESSAGE,
  EXCEL_EXPORT_START_MESSAGE,
  EXCEL_EXPORT_SUCCESS_MESSAGE,
} from "../../../Grid/ExcelExport/excelExportMessages";
import {
  showActionFailureToast,
  showNotSelfClosingActionStartToast,
  showActionSuccessToast,
  ToastId,
} from "../../NotificationForActionButton";
import { toRequestStringWithoutPage } from "../../../Grid/Extensions/kendoDataState";

interface ExcelExportButtonProps {
  readonly url: string;
  readonly dataState: State;
  readonly fileName: string;
}

export default function PdsrExcelExportButton({
  url,
  dataState,
  fileName,
}: ExcelExportButtonProps) {
  const ExcelExportRef = React.useRef<ExcelExport | null>(null);
  const [loading, setLoading] = React.useState(false);
  const toastId: ToastId = React.useRef(null);

  function getFileName(response: AxiosResponse): string | null {
    const headerLine = response.headers["content-disposition"];
    const match = headerLine.match(/filename="([^;]+)";/);
    if (!match) {
      return null;
    }
    return match[1];
  }

  const excelExport = async () => {
    if (ExcelExportRef.current === null) {
      return;
    }

    const dataStateAsQueryString = toRequestStringWithoutPage(dataState);
    setLoading(true);
    toastId.current = showNotSelfClosingActionStartToast(EXCEL_EXPORT_START_MESSAGE);
    axios
      .post(url, dataStateAsQueryString, { responseType: "blob" })
      .then((res) => {
        const filename = getFileName(res) ?? fileName;
        FileDownload(res.data, filename);
        showActionSuccessToast(toastId, EXCEL_EXPORT_SUCCESS_MESSAGE);
      })
      .catch(() => {
        showActionFailureToast(toastId, EXCEL_EXPORT_FAILURE_MESSAGE);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <ExcelExport ref={ExcelExportRef} fileName={fileName}>
      <PageMenuItem align="right" onClick={() => excelExport()} type="link" disabled={loading}>
        <StyledPageMenuIcon icon={faFileExport} />
        EXPORT TABLE
      </PageMenuItem>
    </ExcelExport>
  );
}
